function AddToCartHandler() {
  console.log("Custom AddToCartHandler triggered.");

  // Simulate a minimal expected object
  return {
    getProperties: function () {
      return {
        prescription_type: "Single Vision",
        lens_type: "Anti-Glare",
        pd: "63",
        sphere_left: "-1.25",
        sphere_right: "-1.00"
        // Add any other dummy fields required
      };
    }
  };
}


// function AddToCartHandler() {
//   console.log("Dynamic AddToCartHandler triggered.");

//   // return {
//   //   getProperties: function () {
//   //     return {
//   //       "Prescription Type": document.querySelector('[name="prescription_type"]')?.value || "",
//   //       "Lens Type": document.querySelector('[name="lens_type"]')?.value || "",
//   //       "PD": document.querySelector('[name="pd"]')?.value || "",
//   //       "Sphere Left": document.querySelector('[name="sphere_left"]')?.value || "",
//   //       "Sphere Right": document.querySelector('[name="sphere_right"]')?.value || "",
//   //     };
//   //   }
//   // };
//   return {
//   getProperties: function () {
//     return {
//       "Prescription Type": "Single Vision",
//       "Lens Type": "Anti-Glare",
//       "PD": String(63),
//       "Sphere Left": "-1.25",
//       "Sphere Right": "-1.00",
//       "_bundleId": String(1759815015035)
//     };
//   }
// };

//   console.log(getProperties);
// }
